export const usersPreferenceCenterSelect = "/users/preference_center/select";
